//@import dependencies
import React, {useState} from 'react'
import { useTranslation } from 'react-i18next'
import { Modal } from 'react-bootstrap'

import FullCalendar from '@fullcalendar/react' // must go before plugins
import dayGridPlugin from '@fullcalendar/daygrid' // a plugin!
//@end

//@import components
import IconComponent from 'app_components/commons/icons'
import DataTableComponent from 'app_components/commons/dataTable'
// import CalendarComponent from 'app_components/commons/calendar'
//@end

// @import hooks
import { useColors } from 'app_hooks/useColors'
// @end

// @INFO Import types
import {IActivityCalendarEvent} from 'app_types/campus/academic/activityCalendarTypes'
// @end

// @INFO Import services
// @end

// @INFO Import Styles
import './../activityCalendarModule.scss'

// @ADD Component types
interface IActivityCalendarModuleLayoutProps {
  events: Array<IActivityCalendarEvent>
}

const ActivityCalendarModuleLayout: React.FC<IActivityCalendarModuleLayoutProps> = (props) => {

  const [colors] = useColors()
  const { t } = useTranslation()

  const [modalStatus, setModalStatus] = useState<boolean>(false)
  const [modalData, setModalData] = useState<{items: Array<any>}>({items: []})

  const showDetails = (event: any) => {
    setModalStatus(true)
    setModalData({items: event.event.extendedProps.items})
  }

  const handleCloseModal = (data: any) => {
    setModalStatus(!modalStatus)
  }

  // const DAY_NAMES = ['LU', 'MA', 'MI', 'JU', 'VI','SA', 'DO', ];
  return(
    <div className='activity_calendar-component'>
      <FullCalendar
        headerToolbar={{
          start: 'prev,next',
          center: 'title',
          end: ''
        }}
        titleFormat={{
          month: 'long'
        }}
        plugins={[ dayGridPlugin ]}
        initialView="dayGridMonth"
        events={props.events}
        locale={'es'}
        // dayHeaderContent={(arg) => {
        //   return DAY_NAMES[arg.date.getDay()]
        // }}
        eventDisplay={'background'}
        aspectRatio={1}
        eventClick={showDetails}
      />

      <Modal
        show={modalStatus}
        onHide={handleCloseModal}
        // backdrop='static'
        // keyboard={false}
        centered
        className={`modal_activity_calendar`}
        dialogClassName='modal-dialog-container'
        size="lg"
      >
        <Modal.Header>
          <Modal.Title>
            Actividades
          </Modal.Title>
          <div className="close-button" onClick={() => handleCloseModal({ status: false })}>
            <IconComponent
              color={colors.secondary}
              width='1.5rem'
              height='1.5rem'
              fontawesome={{
                icon: 'fas fa-times-circle',
              }}
            />
          </div>
        </Modal.Header>
        <Modal.Body
          className='modal-media-body modal-activity_calendar-component'
        >
          <DataTableComponent
              data={modalData.items}
              headerKeys={[
                // `${t('modules.activity_details.headers.position')}`,
                `${t('modules.activity_details.headers.activity')}`,
                `${t('modules.activity_details.headers.start_date')}`,
                `${t('modules.activity_details.headers.limit_date')}`,
                `${t('modules.activity_details.headers.delivery_date')}`,
                `${t('modules.activity_details.headers.event_type')}`,
                `${t('modules.activity_details.headers.join')}`,
              ]}
              keys={['activity', 'start_date', 'limit_date', 'delivery_date', 'circle_component', 'component_render_actions']}
              // pagination={props.pagination}
              detailsKey={[]}
              // onPageChange={props.onPageChange}
              onModal={null}
            />
        </Modal.Body>
      </Modal>
    </div>
  )
}

export default ActivityCalendarModuleLayout
